import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {LabAutomationFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isConnectFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import getTestProps from 'test/lib/cypress/getTestProps';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

// exported for test
export const UPLOAD_LINK_TEST_ATTRS = {component: 'SetColumnsMapModal', element: 'goToUploadSpreadsheet'};

export interface ImportColumnHeadersButtonProps {
  goToUploadSpreadsheet: () => void;
  goToImportConnectionFiles?: () => void;
}

export default function ImportColumnHeadersButton(props: ImportColumnHeadersButtonProps): JSX.Element | null {
  const buttonText = 'Copy column headers from file';
  if (!isConnectFeatureEnabled({feature: LabAutomationFeature.LAB_AUTOMATION_IMPORT})) {
    return (
      <a
        className={css(styles.uploadPaneLink)}
        onClick={props.goToUploadSpreadsheet}
        {...getTestProps(UPLOAD_LINK_TEST_ATTRS)}
      >
        {buttonText}
      </a>
    );
  }

  return (
    <Dropdown
      menu={
        <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.MEDIUM}>
          <Option onSelect={props.goToUploadSpreadsheet}>From example file</Option>
          <Option
            onSelect={props.goToImportConnectionFiles}
            isDisabled={!props.goToImportConnectionFiles}
            tooltipTitle={
              props.goToImportConnectionFiles
                ? null
                : 'To use instrument data, select a connection schema and an instrument data type'
            }
          >
            From instrument data
          </Option>
        </Menu>
      }
    >
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        isDropdown={true}
        size={ButtonSize.SMALL}
        text={buttonText}
      />
    </Dropdown>
  );
}

const styles = StyleSheet.create({
  uploadPaneLink: {
    fontSize: '13px',
  },
});
